import React from 'react'

import { Grid, Skeleton } from "@mui/material"

/**
    @param {} props
*/
const Loader = (props) =>
{

    return (
        <Grid container spacing={3} p={1}>
            <Grid item xs={2}>
                <Skeleton variant="circular" width={40} height={40} />
            </Grid>
            <Grid item xs={10}>
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            </Grid>
        </Grid>
    )
}
export default Loader
